import { Box, Chip, IconButton } from "@mui/material";
import { Status } from "../../enums/status.js";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function renderStatus(status) {
	const colors = {
		[Status.PROCESSED]: "success",
		[Status.PENDING]: "default",
		[Status.EXPIRED]: "warning",
		[Status.DECLINED]: "warning",
		[Status.WAITING]: "default",
		[Status.APPROVED]: "success",
	};

	return <Chip label={status} color={colors[status]} size="small" />;
}

function renderTxIdHash(txid_hash) {
	var txTemp = txid_hash ?? "";
	return txTemp.length >= 8 ? txTemp.substring(0, 4) + "..." + txTemp.substring(txTemp.length - 4) : txTemp;
}

export const columns = [
	{ field: "createdAt", headerName: "Date", flex: 1.5, minWidth: 175 },
	{ field: "username", headerName: "Username", flex: 1.5, minWidth: 100 },
	{ field: "agent", headerName: "Agent", flex: 1.5, minWidth: 100 },
	{ field: "network", headerName: "Network", flex: 1.5, minWidth: 75 },
	{ field: "cryptoCurrency", headerName: "Crypto", flex: 1.5, minWidth: 75 },
	{
		field: "status",
		headerName: "Status",
		flex: 0.5,
		minWidth: 100,
		renderCell: (params) => renderStatus(params.value),
	},
	{ field: "cryptoAmount", headerName: "Amount", flex: 1.5, minWidth: 75 },
	{ field: "exchangeRate", headerName: "Exchange", flex: 1.5, minWidth: 75 },
	{ field: "currencyAmount", headerName: "USD", flex: 1.5, minWidth: 75 },
	{ field: "fees", headerName: "Fees", flex: 1.5, minWidth: 75 },
	{ field: "total", headerName: "Total", flex: 1.5, minWidth: 75 },
	{
		field: "address",
		headerName: "To",
		flex: 0.5,
		minWidth: 150,
		renderCell: (params) => {
			const handleCopyRow = (text) => {
				navigator.clipboard
					.writeText(text)
					.then(() => {})
					.catch((err) => {
						console.error("Failed to copy text: ", err);
					});
			};

			return (
				<>
					<Box sx={{ textAlign: "right" }}>
						{renderTxIdHash(params.value)}
						<IconButton
							color="primary"
							aria-label="Copy"
							onClick={() => handleCopyRow(params.value)}
							sx={{ display: "inline-block", border: 0 }}
						>
							<ContentCopyIcon />
						</IconButton>
					</Box>
				</>
			);
		},
	},
	{
		field: "txid_hash",
		headerName: "TxId",
		flex: 0.5,
		minWidth: 80,
		renderCell: (params) => renderTxIdHash(params.value),
	},
];
